import React from 'react';
import { linkifyText } from '../../utils/linkify';

/**
 * Text mit klickbaren Links (Marcel 2026-09-20): Links öffnen in neuem Tab,
 * der Klick blubbert nicht zur Karte hoch (kein Sprung in die Detailseite).
 */
const LinkifiedText: React.FC<{ text: string; className?: string }> = ({ text, className }) => {
  const segments = linkifyText(text);
  return (
    <>
      {segments.map((s, i) =>
        s.type === 'link' ? (
          <a
            key={i}
            href={s.href}
            target="_blank"
            rel="noopener noreferrer nofollow"
            onClick={(e) => e.stopPropagation()}
            className={className ?? 'text-[#3fced1] underline decoration-[#3fced1]/50 hover:decoration-[#3fced1] break-all'}
          >
            {s.value}
          </a>
        ) : (
          <React.Fragment key={i}>{s.value}</React.Fragment>
        ),
      )}
    </>
  );
};

export default LinkifiedText;
